var _style, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "367.51px",
    height: "432.79px",
    viewBox: "0 0 367.51 432.79",
    style: {
      enableBackground: "new 0 0 367.51 432.79"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st2{stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st4{fill:#B8B20F;}\r\n\t.st5{fill:#FFFF00;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st6{fill:#1C77C9;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st7{fill:#29ABE2;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4247 -0.9053 0.9053 0.4247 -118.036 270.2119)",
    className: "st3",
    cx: 153.6,
    cy: 227.98,
    rx: 25.85,
    ry: 26.21
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4247 -0.9053 0.9053 0.4247 -76.7822 323.5724)",
    className: "st3",
    cx: 216.22,
    cy: 222.2,
    rx: 25.85,
    ry: 26.21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M178.75,217.05c1.01-1.77,3-3.01,5.12-3.2c2.12-0.19,4.32,0.67,5.59,2.29c-0.01,1.46-0.19,2.93-0.53,4.35 c-1.05-1.34-2.88-2.1-4.63-1.92c-1.75,0.18-3.37,1.3-4.08,2.82c0.03-1.42-0.45-2.85-1.34-4c1.55-0.92,3.16-1.85,4.98-2.09 c1.81-0.23,3.89,0.43,4.67,2c-1.69-0.41-3.45-0.6-5.19-0.57c-0.64,0.01-1.29,0.06-1.85,0.34c-0.56,0.28-1.01,0.85-0.93,1.45 c1.36,0.2,2.71-0.31,4.06-0.58c1.35-0.27,2.98-0.19,3.81,0.85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M180.19,231.53c1.13-1.74,3.32-2.8,5.47-2.66c2.15,0.14,4.17,1.49,5.03,3.36c0.35,0.75,0.52,1.57,0.92,2.29 c0.4,0.72,1.14,1.37,2,1.36c-2.17,4.77-4.34,9.55-6.51,14.32c-2.59-4.29-5.75-8.27-9.38-11.82c1.16-2.02,1.9-4.25,2.16-6.53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.71,238.49c10.51-6.65,14.67-19.29,15.91-31.14s0.35-24.02,4.01-35.42c1.37-4.27,3.4-8.5,3.25-12.97 s-3.42-9.29-8.18-9.39c0.17-7.56-9.86-13.45-17.02-10c2.24-2.83,1.67-7.28-1.23-9.52c-2.89-2.25-7.65-1.94-10.19,0.66 c1.66-3.48,0.23-8-3.18-10.07c-3.41-2.07-8.39-1.43-11.08,1.42c2.6-2.95,1.1-7.88-2.35-9.92c-3.46-2.04-8.06-1.62-11.72,0.08 c-3.66,1.7-6.58,4.5-9.43,7.25c-2.91-4.76-8.67-7.86-14.52-7.81c-5.85,0.06-11.54,3.27-14.34,8.09c0.16-2.77-2.32-5.22-5.15-5.99 s-5.89-0.19-8.67,0.74c-10.46,3.5-18.75,12.24-21.24,22.4c-9.4-0.11-17.98,5.96-22.57,13.67c-4.59,7.7-5.76,16.79-5.83,25.62 c-0.16,19.99,5,40,14.87,57.71c6.48-7.51,6.19-17.4,5.68-26.95s-1.14-19.37,2.12-28.43s11.47-17.27,21.64-17.79 c10.08-0.52,18.71,6.26,28.15,9.63c10.26,3.67,22.13,3.19,32.02-1.29c7.85-3.55,16.03-9.67,24.22-6.88 c8.49,2.88,10.43,13.14,10.99,23.1c1.37,18,2.74,36,4.11,54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184.91,307.15c5.49,1.63,12-0.62,15.06-5.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.43,262.05c7.07,6.12,15.81,12.69,25.08,10.6c4.84-1.09,8.74-4.4,12.95-6.95 c12.41-7.54,28.87-8.53,42.16-2.53c4.5,2.03,8.65,4.8,13.34,6.38c4.69,1.59,10.29,1.81,14.28-1.03c1.93-1.38,11.43-7.87,13.44-9.16 c2-1.28-2.99,2.93-1.56,4.8c0.65,0.86,0.79,1.97,0.87,3.03c1.44,20.01-13.21,37.92-29.69,50.28c-7.46,5.59-15.93,10.68-25.38,11.25 c-10.27,0.63-20.09-4.19-28.36-10.07c-19.52-13.89-33.62-34.61-39-57.33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M247.22,234.92c1.14,14.19,0.13,28.53-2.97,42.46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.77,231.2c0.36,15.68,3.87,31.3,10.29,45.78"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M172.04,284.51c4.37-5.68,12.65-7.3,20.11-7.12c4.95,0.12,9.96,0.86,14.38,2.95s8.2,5.65,9.63,10.1 c0.86,2.67,0.77,5.76-0.99,8c-1.63,2.07-4.36,3.06-6.98,3.84c-5.77,1.73-11.71,2.96-17.72,3.68c-5.16,0.62-10.71,0.79-15.24-1.62 c-4.07-2.16-6.82-6.37-7.03-10.75c-0.21-4.38,2.13-8.8,5.97-11.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M181.96,293.7c3.05,1.64,6.84,2.03,10.19,1.05s6.23-3.32,7.75-6.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar4);
export default __webpack_public_path__ + "static/media/avatar4.d6c00d378b4939deff30eff30703b7df.svg";
export { ForwardRef as ReactComponent };